import FormDetails from ".";

export const formDetailsRoutes = (data) => [
  {
    path: "/admin/forms/sections",
    title: "form",
    layout: "admin",
    routeType: "admin",
    component: FormDetails,
  },
];
